import { Alert, Drawer, pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const StyledAlert = styled(Alert) `
  margin-bottom: ${theme.spacing.xl};
`;
export const StyledDrawer = styled(Drawer) `
  width: 100%;
  max-width: ${pxToRem(360)};
  background-color: ${theme.semantic.surface.primary};
`;
export const ContentContainer = styled.div `
  padding: ${theme.spacing.xl};
`;
export const AccessSectionContainer = styled.div `
  & + & {
    margin-top: ${theme.spacing.xl};
  }
`;
